var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13961",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40918"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72387",
    d: "M41.082 25.8a.276.276 0 0 0-.09-.457 5.41 5.41 0 0 0-6.85 7.243l-8.407 7.882a2.327 2.327 0 1 0 3.289 3.289l7.879-8.4a5.41 5.41 0 0 0 7.213-6.95.276.276 0 0 0-.455-.084l-3.088 3.088-2.549-2.549z",
    transform: "translate(-22.76 -22.757)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72388",
    d: "m126.348 142.9-2.142 2.142 4.235 4.518a2.339 2.339 0 1 0 3.307-3.307l-3.335-3.126q-.22.018-.446.018a5.436 5.436 0 0 1-1.619-.245z",
    transform: "translate(-111.784 -128.555)",
    style: {
      fillRule: "evenodd",
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72389",
    d: "m27.162 37.241-1.2 1.2 1.885 3.1h1.024L32 44.64l1.367-1.367-3.1-3.133v-1.015z",
    transform: "translate(-23.627 -33.741)",
    style: {
      fill: "current"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSchedule);
export default __webpack_public_path__ + "static/media/ic_schedule.bad558a955fb7523361847de9214a440.svg";
export { ForwardRef as ReactComponent };